import { classNames } from '@payfit/growth-platform-brand-system-v2';
import { fontBodyMiniMedium } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { shortcode } from 'apps/website/src/utils/Shortcode';
import { SiteLocale } from 'apps/website/types/dato';
import React, { ReactNode } from 'react';
type TotalProps = {
  locale: SiteLocale;
  totalPriceLabel: string;
  price?: number;
  nbEmployee: number;
  breakdownTooltip?: ReactNode;
};

const Total = ({
  locale,
  totalPriceLabel,
  price,
  nbEmployee,
  breakdownTooltip,
}: TotalProps) => {
  if (!price) return null;
  return (
    <div>
      <div
        className={classNames('PriceBox_Total', fontBodyMiniMedium, 'inline')}
        style={{
          lineHeight: '1.6rem',
        }}
        dangerouslySetInnerHTML={{
          __html: shortcode(totalPriceLabel || '', locale)
            .pricingPage.applyTotal({
              total: price,
            })
            .applyNbEmployee({ nbEmployee })
            .toString()
            .replace(/\n/g, '<br>'),
        }}
      />
      <div className="ml-2 inline align-middle">{breakdownTooltip}</div>
    </div>
  );
};

export default Total;
